"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ContentCollapse_1 = require("./class/ContentCollapse");
ContentCollapse_1.ContentCollapse.initCollapse();
